import { EDITPOLICY_SUCCESS, EDITPOLICY_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const editPolicyReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDITPOLICY_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case EDITPOLICY_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default editPolicyReducer;
